import * as React from "react";
import { SvgRoot } from "./SvgRoot";

const RefreshIcon = props => {
    return (
        <SvgRoot {...props}>
            <>
                <path fill={props.nativeColor} d="M5.3,15l1.8-2.2c0.1-0.1,0-0.2-0.1-0.2l-3.7,0.2c-0.1,0-0.2,0.1-0.1,0.2l2,2C5.2,15.1,5.3,15.1,5.3,15z"/>
                <g fill="none" stroke={props.nativeColor} strokeLinecap="round" strokeLinejoin="round">
                    <polyline points="12.2,9.3 12.2,12.8 14.8,14.7"/>
                    <path d="M8.3,18.4c1.3,1,3,1.6,4.8,1.6c4.4,0,8-3.6,8-8s-3.6-8-8-8s-8,3.6-8,8c0,0.5,0.1,1,0.2,1.5"/>
                </g>
            </>
        </SvgRoot>
    );
};

export default RefreshIcon;


// WEBPACK FOOTER //
// ./src/components/Icons/RefreshIcon.tsx